import { render, staticRenderFns } from "./CardioEventsFilter.vue?vue&type=template&id=b05f85f8&"
import script from "./CardioEventsFilter.vue?vue&type=script&lang=js&"
export * from "./CardioEventsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports